









































import { OptionItem } from "@/graphql/client";
import { Component, Emit, Vue } from "vue-property-decorator";
import optionService from "@/service/optionService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class OptionItemEditDialog extends Vue {
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: OptionItem = optionService.defaultOptionItem;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  //---------------------------
  // methods
  //---------------------------
  /**
   * ダイアログを表示します.
   */
  public open(item: OptionItem): void {
    this.item = item;

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  deleteItem(): void {
    this.isProgressing = true;
    //delete
    optionService
      .deleteOptionItem(this.item)
      .then((result) => {
        this.isProgressing = false;
        this.notifySuccess(result as OptionItem);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  /**
   * 処理成功
   */
  @Emit("onSuccess")
  public notifySuccess(deleted: OptionItem): OptionItem {
    return deleted;
  }
}
